module.exports = __webpack_public_path__ + "static/media/wallpaperpc.40552568.jpg";